<template lang="pug">
.coupon-exchange-container
  input(placeholder='请输入兑换码', v-model='code')
  .btn(@click='exchange') 立即兑换
</template>

<script>
import Toast from '@/components/toast';
import { exchangeCoupon } from '@/api/activity';
import { getTokenAndLocation } from '../../utils';

export default {
  data() {
    return {
      code: '',
      exchanging: false,
    };
  },
  methods: {
    async exchange() {
      if (!this.code || this.exchanging) {
        return;
      }
      const { token, cityCode, adCode } = await getTokenAndLocation();
      if (!token) {
        return;
      }
      this.exchanging = true;
      exchangeCoupon({
        code: this.code, token, cityCode, adCode,
      }).then((res) => {
        if (!res || !res.data) {
          Toast.show('兑换失败，请稍后重试');
          return;
        }
        const { exchangeResult, exchangeResultText } = res.data;
        if (exchangeResult === 0) {
          Toast.show(exchangeResultText);
          return;
        }
        Toast.show('兑换成功，请返回钱包页查看');
      }).catch((e) => Toast.showError(e)).then(() => { this.exchanging = false; });
    },
  },
};
</script>

<style lang="less">
.coupon-exchange-container {
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 0.5rem;

  input {
    margin: 0.2rem 0;
    border: 1px solid #eee;
    width: 3rem;
    height: 0.48rem;
    font-size: 18px;
    outline: 0;
    border-radius: 8px;
    padding: 0.02rem 0.1rem;
    -webkit-appearance: none;
  }

  .btn {
    background: #0b82f1;
    font-size: 18px;
    width: 3rem;
    line-height: 0.48rem;
    height: 0.48rem;
    text-align: center;
    color: #fff;
    border-radius: 8px;
  }
}
</style>
